// @ts-nocheck
import {getAppLocale, getLocalizedURL} from '@intl/adobe-locales';
import Button from '@react/react-spectrum/Button';
import Dialog from '@react/react-spectrum/Dialog';
import Close from '@react/react-spectrum/Icon/Close';
import InfoOutline from '@react/react-spectrum/Icon/InfoOutline';
import ModalContainer from '@react/react-spectrum/ModalContainer';
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger';
import {addToast, Toast} from '@react/react-spectrum/Toast';
import Tooltip from '@react/react-spectrum/Tooltip';
import Wait from '@react/react-spectrum/Wait';
import React from 'react';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';
import {Utils} from '../../../utils/Globals';
import {store} from '../../client';
import {LIBRARY_CREATED} from '../../types';
import {CREATE, FETCH_FAIL, UPLOAD} from './constants';
import './postDownload.scss';
import SaveToLibraryManager from './saveToLibraryManager';

type State = {
	library: object | undefined;
	status: string;
	librarySaved: boolean;
	saveToLibClicked: boolean;
};

type Props = {
	onClose: Function;
	imageBlob: Blob;
	mimeType: string;
	filename: string;
	actionID: string;
};
class PostDownload extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			librarySaved: false,
			status: store.getState().saveToLibrary.status,
			library: store.getState().saveToLibrary.library,
			saveToLibClicked: false,
		};
		store.subscribe(() => {
			if (this.state.status !== store.getState().saveToLibrary.status) {
				this.setState(
					{library: store.getState().saveToLibrary.library, status: store.getState().saveToLibrary.status},
					() => {
						this.state.saveToLibClicked ? this.saveLibrary() : null;
					},
				);
			}
		});
	}

	sendAnalytic = (workflow, eventType, eventSubType, eventSubCategory, errordesc) => {
		const analytics = new AnalyticsUtil(true);
		analytics.ingest.initializeDefaultData();
		const data: dataObject = {
			setEventWorkFlow: workflow,
			setEventType: eventType,
			setEventSubtype: eventSubType,
			setEventSubcategory: eventSubCategory,
			setEventErrorDesc: errordesc,
		};
		analytics.logAnalytics(data);
		return analytics.ingest.sendToIngest();
	};

	showToast(msg, type, label, goToAsset) {
		addToast(
			<Toast closable variant={type} actionLabel={label} onAction={goToAsset}>
				{msg}
			</Toast>,
			100000,
		);
	}

	// after library is saved successfully
	handlePostSaveToLibrary = () => {
		this.sendAnalytic('CCH Next Steps', 'render', 'success', 'Save to library', null);
		this.setState({librarySaved: true});
		this.showToast(
			Utils.localizedStrings['ccx.postDownload.librarySaved'],
			'success',
			Utils.localizedStrings['ccx.postDownload.toastLabel'],
			() => {
				this.sendAnalytic('CCH Next Steps toast', 'click', 'Open', null, null);
				window.location.href = getLocalizedURL(
					window.CONFIG.SERVICES.cclibrary.assetWeb,
					window.cchome.util.getStartupLanguage(),
				);
			},
		);
		this.sendAnalytic('CCH Next Steps toast', 'render', null, null, null);
	};

	handleError = (err) => {
		this.sendAnalytic('CCH Next Steps', 'api-error', 'error', null, JSON.stringify(err));
		this.setState({librarySaved: false, saveToLibClicked: false});
		this.showToast(Utils.localizedStrings['ccx.postDownload.toastFail'], 'error', '', () => {});
	};

	// this function is triggered when save to library CTA is clicked
	handleSaveToLibrary = () => {
		this.setState({saveToLibClicked: true});
		this.saveLibrary();
	};

	// handles the actual work of saving the asset to library
	saveLibrary = () => {
		if (this.state.status === CREATE) {
			SaveToLibraryManager
				.addNewLibrary()
				.then(async(response) => {
					const resp = response[0];
					// after a new library is created it takes some time before it can be used
					// doing these calls to check if the created lib is ready to use, so that assest can be pushed
					let i = 0;
					let lib = undefined;
					for (i = 0; i < 10; i++) {
						lib = await SaveToLibraryManager.validateLibCreation(resp.library_urn).catch((err) => {});
						if (lib) {
							break;
						}
					}
					if (i === 10) {
						// means library was not created or validation failed, status will remain CREATE
						this.handleError('Library creation timedout');
					}
					else {
						// library created changing the status from CREATE to UPLOAD
						store.dispatch({type: LIBRARY_CREATED, payload: lib.data});
					}
				})
				.catch((err) => {
					this.handleError(err);
				});
		}
		else if (this.state.status === UPLOAD) {
			if (this.props.imageBlob.size > 5242880) {
				SaveToLibraryManager
					.addLargeImageAssettoLibrary(
						this.props.imageBlob,
						this.state.library.id,
						this.state.library.library_urn,
						this.state.library.ownership,
						this.props.mimeType,
						this.props.filename,
					)
					.then((resp) => {
						this.handlePostSaveToLibrary();
					})
					.catch((err) => {
						this.handleError(err);
					});
			}
			else {
				SaveToLibraryManager
					.addSmallImageAssettoLibrary({
						libID: this.state.library.id,
						libURN: this.state.library.library_urn,
						libtype: this.state.library.ownership,
						format: this.props.mimeType,
						asset: this.props.imageBlob,
						filename: this.props.filename,
					})
					.then((resp) => {
						this.handlePostSaveToLibrary();
					})
					.catch((err) => {
						this.handleError(err);
					});
			}
		}
		else if (this.state.status === FETCH_FAIL) {
			this.handleError('Failed to fetch user libraries');
		}
	};

	getTrackingID = (actionID) => {
		if (actionID === 'remove-background') {
			return 'CMR429P7';
		}
		else if (actionID === 'image-resize') {
			return 'ZXL8DZSS';
		}
		else if (actionID === 'convert-to-jpg') {
			return '12B9DW2R';
		}
	};

	saveToLibCtaText = () => {
		if (this.state.librarySaved) {
			return Utils.localizedStrings['ccx.postDownload.savedToLib'];
		}
		else if (this.state.saveToLibClicked) {
			return Utils.localizedStrings['ccx.postDownload.saving'];
		}
		return Utils.localizedStrings['ccx.postDownload.saveToLib'];

	};

	componentDidMount() {
		const img = document.createElement('img');
		img.src = URL.createObjectURL(this.props.imageBlob);
		const parent = document.querySelector('.postDownloadMainImage');
		if (parent) {
			parent.appendChild(img);
		}
		// adding checker board pattern as the loaded image's background
		// this needs to be done after the image is loaded so that it fits the image dimensions
		img.addEventListener('load', () => {
			img.classList.add('postDownloadImageBackground');
		});
	}

	render() {
		return (
			<Dialog
				autoFocusButton={null}
				backdropClickable={false}
				confirmDisabled={false}
				disableEscKey
				isDismissible={false}
				keyboardConfirm={false}
				id='postDownloadDialog'
				className='postDownloadDialog'
			>
				<div className='postDownloadDialogWrapper'>
					<div className='postDownloadMainImage' />
					<div className='postDownloadContent'>
						<img src='/assets/common/QAPostDownloadDone.png' />
						<h1>{Utils.localizedStrings['ccx.postDownload.title']}</h1>
						<h3>
							{window.cchome.util.hasFeature('ccx_sept')
								? Utils.localizedStrings['ccx.postDownload.Content']
								: Utils.localizedStrings['ccx.postDownload.oldContent']}
						</h3>
						{window.cchome.util.hasFeature('ccx_sept') ? (
							<Button
								variant='primary'
								onClick={() => {
									this.sendAnalytic('CCH Next Steps', 'click', null, 'Try CCExpress', null);
									window.open(
										`${window.CONFIG.TRY_CCX
										}?promoid=${
											this.getTrackingID(this.props.actionID)
										}&mv=other&locale=${
											getAppLocale('spark', window.cchome.util.getStartupLanguage(), 'en')}`,
									);
									if (this.state.librarySaved) {
										this.props.onClose();
									}
								}}
								label={Utils.localizedStrings['ccx.postDownload.tryCCX']}
							/>
						) : null}
						{window.cchome.util.hasFeature('ccx_sept') ? (
							<div className='postDownloadPartition'>
								<hr />
								<p>{Utils.localizedStrings['ccx.postDownload.or']}</p>
								<hr />
							</div>
						) : null}
						<Button
							variant='cta'
							onClick={() => {
								this.sendAnalytic('CCH Next Steps', 'click', 'start', 'Save to library', null);
								this.handleSaveToLibrary();
							}}
							disabled={this.state.saveToLibClicked}
							icon={this.state.saveToLibClicked && !this.state.librarySaved ? <Wait size='S' /> : null}
							label={this.saveToLibCtaText()}
						/>
						{window.cchome.util.hasFeature('ccx_sept') ? (
							<div
								className='postDownloadInfo'
								onMouseEnter={() => {
									this.sendAnalytic('CCH Next Steps', 'hover', null, 'infoButton', null);
								}}
							>
								<OverlayTrigger placement='top' trigger={['hover', 'click']}>
									<Button variant='tool' icon={<InfoOutline />} />
									<Tooltip
										className='postDownloadToolTip'
										open
										placement='top'
										role='tooltip'
										variant='inspect'
									>
										{Utils.localizedStrings['ccx.postDownload.libraryInfo']}
									</Tooltip>
								</OverlayTrigger>
							</div>
						) : null}
					</div>
				</div>
				<Button
					variant='tool'
					icon={<Close />}
					aria-label='Close'
					onClick={() => {
						this.sendAnalytic('CCH Next Steps', 'click', 'dismiss', null, null);
						this.props.onClose();
					}}
					id='quick-task-close-button'
				/>
			</Dialog>
		);
	}
}

export default function showPostDownload(imageBlob: Blob, mimeType: string, filename: string, actionID: string) {
	const key = ModalContainer.show(
		<PostDownload
			onClose={() => {
				ModalContainer.hide(key);
			}}
			imageBlob={imageBlob}
			mimeType={mimeType}
			filename={filename}
			actionID={actionID}
		/>,
	);
}
